// Settings translations for React Admin resource
export const settingsResource = {
  name: 'Settings',
  fields: {
    key: 'Key',
    value: 'Value',
    type: 'Type',
    description: 'Description',
    updatedAt: 'Updated At',
  },
};

// Custom settings translations for components
export const settings = {
  logoUploaded: 'Logo uploaded successfully',
  uploading: 'Uploading...',
  changeLogo: 'Change Logo',
  invalidFileType: 'Invalid file type. Only PNG, JPEG, and SVG are allowed',
  fileTooLarge: 'File too large. Maximum size is 5MB',
  authRequired: 'Authentication required. Please log in again.',
  noPermissionView: "You don't have permission to view settings.",
  noPermissionEdit: 'You need admin permissions to edit settings.',
  noSettings: 'No settings available in this category.',
  translations: 'Translations',
  manageTranslations: 'Manage Translations',
  originalValue: 'Original Value (English)',
  traditionalChinese: 'Traditional Chinese (繁體中文)',
  enterTranslation: 'Enter Traditional Chinese translation',
  cancel: 'Cancel',
  saveTranslations: 'Save Translations',
  categories: {
    branding: 'Branding',
    appearance: 'Appearance',
    system: 'System',
    payment: 'Payment',
  },
  fields: {
    company_name: 'Company Name',
    company_logo: 'Company Logo',
    theme_config: 'Theme Configuration',
    system_timezone: 'System Timezone',
    invoice_prefix: 'Invoice Prefix',
    database_version: 'Database Version',
    maintenance_mode: 'Maintenance Mode',
    maintenance_message: 'Maintenance Message',
    mpay_callback_webhook_url: 'MPay Callback Webhook URL',
    payment_retry_delay_minutes: 'Payment Retry Delay Minutes',
    payment_retry_max_attempts: 'Payment Retry Max Attempts',
    payment_webhook_enabled: 'Payment Webhook Enabled',
    payment_webhook_secret: 'Payment Webhook Secret',
    payment_webhook_timeout: 'Payment Webhook Timeout',
    payment_webhook_url: 'Payment Webhook URL',
    wallet_charge_decimal_places: 'Wallet charge decimal places',
    rfid_charge_decimal_places: 'RFID card charge decimal places',
  },
  descriptions: {
    company_name: 'The name of your company or organization',
    company_logo: 'Your company logo displayed in the admin interface',
    theme_config: 'Visual theme and color scheme settings',
    system_timezone: 'Default timezone for the system',
    invoice_prefix: 'Prefix used for invoice numbers (e.g., RCP, INV, EV)',
    database_version: 'Current database schema version corresponding to migration file number',
    maintenance_mode: 'Enable maintenance mode',
    maintenance_message: 'Message displayed during maintenance',
    mpay_callback_webhook_url: 'Webhook URL for mPay payment gateway callbacks',
    payment_retry_delay_minutes: 'Minutes to wait before retrying failed payments',
    payment_retry_max_attempts: 'Maximum number of payment retry attempts',
    payment_webhook_enabled: 'Enable/disable payment webhook calls',
    payment_webhook_secret: 'Secret key for authenticating webhook requests',
    payment_webhook_timeout: 'Webhook timeout in seconds',
    payment_webhook_url: 'Webhook URL for payment settlement processing',
    wallet_charge_decimal_places: 'The amount charged to an app wallet (app sessions and RFID cards linked to a wallet) is rounded to these decimal places, half away from zero',
    rfid_charge_decimal_places: 'The amount billed to an RFID-only card is rounded to these decimal places, half away from zero',
  },
  decimalPlaces: {
    one: '1 decimal place (nearest HK$0.10)',
    two: '2 decimal places (to the cent)',
    choose: 'Decimal places',
    edit: 'Change the decimal places',
    save: 'Save the decimal places',
    invalid: 'The stored value %{value} is not 1 or 2',
  },
  timezone: {
    updated: 'Timezone updated successfully',
    updateFailed: 'Failed to update timezone',
    currentTime: 'Current time',
  },
  errors: {
    loadFailed: 'Failed to load settings',
    updateFailed: 'Failed to update setting',
    uploadFailed: 'Failed to upload logo',
  },
};